const SizeLegend = ({
  minValue,
  maxValue,
  metric,
  isDownload = false,
}: {
  minValue: number;
  maxValue: number;
  metric: 'bgRatio' | 'oddsRatio' | 'intersection';
  isDownload?: boolean;
}) => {
  const border = isDownload ? 'border border-gray-500' : '';

  const metricLabel =
    metric === 'bgRatio' ? 'bgRatio' : metric === 'oddsRatio' ? 'Odds Ratio' : 'Intersection Count';

  const formatValue = (value: number): string => {
    if (metric === 'intersection') {
      return value.toString();
    }
    return value.toFixed(metric === 'bgRatio' ? 6 : 2);
  };

  return (
    <div className="flex items-center justify-center gap-8 text-sm">
      <span className={`${isDownload ? 'font-bold' : 'font-semibold'} text-gray-700`}>
        Circle Size ({metricLabel}):
      </span>
      <div className="flex items-center gap-2">
        <div
          className={`rounded-full bg-gray-400 ${border}`}
          style={{ width: isDownload ? '12px' : '10px', height: isDownload ? '12px' : '10px' }}
        ></div>
        <span>Min ({formatValue(minValue)})</span>
      </div>
      <div className="flex items-center gap-2">
        <div className={`rounded-full bg-gray-400 ${border}`} style={{ width: '25px', height: '25px' }}></div>
        <span>Medium</span>
      </div>
      <div className="flex items-center gap-2">
        <div className={`rounded-full bg-gray-400 ${border}`} style={{ width: '40px', height: '40px' }}></div>
        <span>Max ({formatValue(maxValue)})</span>
      </div>
    </div>
  );
};

export default SizeLegend;
